import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';

import Level2 from './images/2.jpg';

export default function ClassDefault({ onComplete }) {
  const [showText, setShowText] = useState(false);
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;
    
    timeouts.push(setTimeout(() => setShowText(true), currentTime));
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => setShowImage(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Account Classification</h1>
      
      <p className={getAnimationClass(showText)}>
        This level is slightly more challenging. You now have to sort accounts into their correct financial statement elements. You might even see some unfamiliar accounts so just try your best.
      </p>
      
      <img 
        src={Level2} 
        alt="Classification Game" 
        className={`transition-image big-margin ${getAnimationClass(showImage)}`}
      />
    </>
  );
}